import { render } from "./JMUploads.vue?vue&type=template&id=53e2bd1e&ts=true&lang=pug"
import script from "./JMUploads.vue?vue&type=script&lang=ts"
export * from "./JMUploads.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__